import React from "react";
import {Button, Icon, Modal} from "antd";
import PropTypes from "prop-types";
import DocumentCreate from "../../containers/Document/create";
import {fetchSubDocumentFilter} from "../../appRedux/actions";
import {connect} from "react-redux";

class DocumentList extends React.Component {

  id = 0;
  state = {
    visible: false,
    documentDataList: [],
  };

  componentDidMount() {
    this.props.fetchSubDocumentFilter('Document');
    const {data = []} = this.props;
    this.setState({
      documentDataList: data
    })
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data && JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)) {
      this.setState({
        documentDataList: nextProps.data
      })
    }
  }

  remove = index => {
    const {documentDataList} = this.state;
    documentDataList.splice(index, 1);
    this.setState({
      documentDataList: documentDataList
    }, () => {
      this.props.getAssetDocumentData(documentDataList);
    });
  };

  showModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      visible: true,
    });
  };
  handleCancel = e => {
    this.setState({
      visible: false,
    });
  };

  handleChange = (e) => {
  };

  handleSubmit = (values, id) => {
    const {documentDataList} = this.state;
    const data = {
      file: values.files.file,
      name: values.name,
      renewalDate: values.renewalDate,
      documentDate: values.documentDate,
      type: values.type,
      amount: values.amount || 0,
    };
    documentDataList.push(data);
    this.setState({
      documentDataList: documentDataList,
      visible: false
    }, ()=> {
      this.props.getAssetDocumentData(this.props.index, documentDataList);
    });
  };

  edit = (id) => {
    this.props.history.push(`/document/edit/${id}`);
  };

  render() {
    const {
      item,
      isDisabled,
      hideEdit = false,
      hideRemove = false,
      subDocumentFilters,
      data,
      clearData = false,
      title = '',
      resource = '',
      disableAdd = false
    } = this.props;
    const {viewOption} = this.props;
    const {visible, documentDataList} = this.state;
    const style = {
      marginTop: '10px',
      border: '1px dashed #000',
      padding: '20px',
      borderRadius: '9px',
      display: 'flex',
      justifyContent: 'space-between'
    };
    const formItems = documentDataList && documentDataList.length ? documentDataList.map((item, index) => {
      if (this.props.resource === 'PreVerificationApproval') {
        return <div key={`${item._id}${index}`} style={style}>
          <div>
            {item.name} - <span> {item && item.url ?
            <a href={item && item.url} target="_blank">{item && item.url}</a> :
            <span>{item && item.name}</span>
          }
          </span>
          </div>
          <div>
            {item._id ? <Button
              disabled={(viewOption && viewOption.resourceName === 'salesInvoice' && viewOption.viewOption === true) ? true : hideEdit || isDisabled}
              type='primary' onClick={() => {
              this.edit(item._id)
            }}>Edit</Button> : ''}
            <Button
              type='danger'
              style={{marginLeft: '15px'}}
              disabled={(viewOption && viewOption.resourceName === 'salesInvoice' && viewOption.viewOption === true) ? true : hideRemove || isDisabled}
              onClick={() => this.remove(`${index}`)}
            >Remove</Button>
          </div>
        </div>
      } else {
        return <div key={index} style={style}>
          <div>
            {item.name} - <span>{item && item.file && item.file.path ?
            <a href={item && item.file && item.file.path} target="_blank">{item && item.file && item.file.name}</a> :
            <span>{item && item.file && item.file.name}</span>}</span>
          </div>
          <div>
            {item._id ? <Button
              disabled={(viewOption && viewOption.resourceName === 'salesInvoice' && viewOption.viewOption === true) ? true : hideEdit || isDisabled}
              type='primary' onClick={() => {
              this.edit(item._id)
            }}>Edit</Button> : ''}
            <Button
              type='danger'
              disabled={(viewOption && viewOption.resourceName === 'salesInvoice' && viewOption.viewOption === true) ? true : hideRemove || isDisabled}
              onClick={() => this.remove(`${index}`)}
            >Remove</Button>
          </div>
        </div>
      }
    }) : <> </>;
    return (
      <div
        style={resource && (resource === 'ThirdPartyWorkQuotation' || resource === 'InvoiceEntry') ? {width: '48%'} : {width: '100%'}}>
        <Modal
          title="Document"
          visible={(viewOption && viewOption.resourceName === 'salesInvoice' && viewOption.viewOption === true) ? false : visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          footer={null}
        >
          <DocumentCreate data={data}
                          filters={subDocumentFilters}
                          modules={''}
                          subMaster={true}
                          title={'CREATE'}
                          visible={(viewOption && viewOption.resourceName === 'salesInvoice' && viewOption.viewOption === true) ? false : visible}
                          isDisabled={isDisabled}
                          resource={resource === 'PreVerificationApproval' ? 'Documents' : item && item.options.ref}
                          loading={false}
                          onChange={this.handleChange}
                          onSubmit={this.handleSubmit}
          />
        </Modal>
        {!clearData && <div style={resource === 'PreVerificationApproval' ? {marginTop: '10px'} : {}}> Documents </div>}
        {!clearData && formItems}
        <Button
          disabled={title && title === 'VIEW' ? true : disableAdd ? true : isDisabled}
          type="dashed" onClick={this.showModal}
          style={{width: '100%', marginTop: '15px'}}>
          <Icon type="plus"/> Add Asset Documents
        </Button>
      </div>
    )
  }
}

const mapStateToProps = ({commonData}) => {
  return {
    subDocumentFilters: commonData.subDocumentFilters
  }
};

function mapDispatchToProps(dispatch) {
  return {
    fetchSubDocumentFilter,
  };
}

export default connect(mapStateToProps, mapDispatchToProps())(DocumentList);
DocumentList.defaultProps = {};

DocumentList.propTypes = {
  item: PropTypes.object
};
